/**
 * Transição lista ↔ ficha com a View Transitions API: o nome e o anel da
 * linha clicada viram o nome e o anel do hero (elemento compartilhado); o
 * resto faz o fade de página (CSS ::view-transition-*). Sem a API, navega
 * direto.
 */
import { flushSync } from "react-dom";

import { prefereMenosMovimento } from "./movimento";

const CHAVE_DO_ULTIMO = "pharuerp:clientes-legado:ultimo-aberto";
const NOMES = { nome: "cl-nome", anel: "cl-anel" };
/** Liga o CSS ::view-transition-* desta tela só enquanto a transição roda. */
const CLASSE_DURANTE = "cl-vt";
/** Na volta para a lista, a linha do último cliente aberto recebe o nome e o anel. */
const CLASSE_DA_VOLTA = "cl-vt-volta";

let transicaoEmCurso = false;

/**
 * A tela que chega por transição entra pronta (sem a cascata de entrada): é
 * a View Transition que anima, e o nome e o anel precisam estar visíveis no
 * instante da foto.
 */
export function chegandoPorTransicao() {
  return transicaoEmCurso;
}

function cliqueComum(evento) {
  return !evento || (evento.button === 0 && !evento.metaKey && !evento.ctrlKey && !evento.shiftKey && !evento.altKey);
}

/** Marca o nome e o anel do cliente na lista para a transição compartilhada. */
function marcarOrigem(id) {
  const linha = document.querySelector(`[data-linha="${CSS.escape(id)}"]`);
  if (!linha) return;
  const nome = linha.querySelector('[data-vt="nome"]');
  const anel = linha.querySelector('[data-vt="anel"]');
  if (nome) nome.style.viewTransitionName = NOMES.nome;
  if (anel) anel.style.viewTransitionName = NOMES.anel;
}

export function ultimoClienteAberto() {
  try {
    return sessionStorage.getItem(CHAVE_DO_ULTIMO);
  } catch {
    return null;
  }
}

function lembrar(id) {
  try {
    sessionStorage.setItem(CHAVE_DO_ULTIMO, id);
  } catch {
    // Sem sessionStorage (aba privada restrita): só não haverá o elemento compartilhado na volta.
  }
}

export function navegarComTransicao(navigate, destino, { id, volta = false } = {}) {
  if (id) lembrar(id);
  if (typeof document === "undefined" || !document.startViewTransition || prefereMenosMovimento()) {
    navigate(destino);
    return;
  }
  if (id && !volta) marcarOrigem(id);
  const raiz = document.documentElement;
  const classes = volta ? [CLASSE_DURANTE, CLASSE_DA_VOLTA] : [CLASSE_DURANTE];
  raiz.classList.add(...classes);
  transicaoEmCurso = true;
  const transicao = document.startViewTransition(() => {
    flushSync(() => navigate(destino));
  });
  transicao.finished.finally(() => {
    transicaoEmCurso = false;
    raiz.classList.remove(...classes);
  });
}

/** Volta da ficha para a lista (o nome e o anel do hero voltam para a linha). */
export function voltarParaALista(navigate, destino = "/legado/clientes") {
  navegarComTransicao(navigate, destino, { volta: true });
}

/** Handler de clique de um <Link> para a ficha: Ctrl/⌘-clique abre em nova aba normalmente. */
export function abrirFichaAoClicar(navigate) {
  return (evento, id) => {
    if (!cliqueComum(evento)) return;
    evento.preventDefault();
    navegarComTransicao(navigate, `/legado/clientes/${id}`, { id });
  };
}

export { NOMES as NOMES_DA_TRANSICAO };
